module.exports = new __parcel__URL__("JiraServiceManagement.e75af785.svg").toString();